import script from "./PrettyJsonRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./PrettyJsonRenderer.vue?vue&type=script&setup=true&lang=js"

import "./PrettyJsonRenderer.vue?vue&type=style&index=0&id=b712af22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b712af22"]])

export default __exports__